import React from 'react';

interface AlertNoteProps {
  variant: 'success' | 'warning' | 'danger';
  children: React.ReactNode;
}

const AlertNote: React.FC<AlertNoteProps> = ({ variant, children }) => (
  <div className={`alert alert-${variant}`} role="alert">
    {children}
  </div>
);

export default AlertNote;
